import React from 'react';

import { Heading, Typography } from '@lumapps/lumx/react';

interface AskAiAnswerHeaderProps {
    className?: string;
    originalQuery?: string;
}

export const AskAiAnswerHeader: React.FC<AskAiAnswerHeaderProps> = ({ className, originalQuery }) => {
    return (
        <Heading as="h3" typography={Typography.title} className={className}>
            {originalQuery}
        </Heading>
    );
};
